// extracted by mini-css-extract-plugin
export default {"stayLoggedInInput":"LoginForm_stayLoggedInInput__mFUo9"};